import React from 'react';
import { Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import backArrowIcon from '../../../../../assets/img/backarrow.png';

const BackToSearchItem = () => {
  const navigate = useNavigate();

  const dashboard = () => {
    navigate(`/`);
  };

  return (
    <Nav.Item className="back-search">
      <Nav.Link
        href="#0"
        onClick={dashboard}
        id="backarrow"
        className="simpleLink"
      >
        <img src={backArrowIcon} alt="backarrow" className="imgArrow" />
        Back to Search
      </Nav.Link>
    </Nav.Item>
  );
};

export default BackToSearchItem;
